import { graphql } from "../../gql";
import "../fragments/quiz/quiz";

export const GET_PROJECT_WITH_GAMES = graphql(/* GraphQL */ `
  query ProjectPublic($projectId: UUID!) {
    projectPublic(projectId: $projectId) {
      id
      name
      status
      hideDatagameBranding
      hideSummaryPage
      showLeaderboard
      showCustomEndScreen
      customEndScreenConfiguration {
        id
        mainHeader
        mainHeaderColor
        title
        titleColor
        description
        descriptionColor
        backgroundColor
        logo {
          id
          name
          url
        }
        backgroundImage {
          id
          name
          url
        }
      }
      leaderboardConfiguration {
        id
        createdAt
        updatedAt
        header
        headerColor
        subheader
        subheaderColor
        showTimer
        numberOfPlayers
        nicknameQuestion
        nicknameQuestionColor
        nicknameLabel
        tableNicknameLabel
        tableScoreLabel
        tableTimeLabel
        backgroundColor
        backgroundImage {
          id
          name
          url
        }
      }
      games {
        id
        kind
        name
        responseCount
        createdAt
        updatedAt
        configuration {
          __typename
          ... on QuickRankConfiguration {
            ...QuickRankConfiguration
          }
          ... on RankifierConfiguration {
            ...RankifierConfiguration
          }
          ... on SwiperConfiguration {
            ...SwiperConfiguration
          }
          ... on WordopolisConfiguration {
            ...WordopolisConfiguration
          }
          ... on TriviaConfiguration {
            ...TriviaConfiguration
          }
          ... on WordleConfiguration {
            ...WordleConfiguration
          }
          ... on QuizConfiguration {
            ...QuizConfiguration
          }
        }
      }
    }
  }
`);

export const SWIPER_GAME_RESULTS = graphql(`
  query SwiperGameResults($responseId: String!) {
    swiperGameResults(responseId: $responseId) {
      match
    }
  }
`);

export const RANKIFIER_GAME_RESULTS = graphql(`
  query RankifierGameResults($responseId: String!) {
    rankifierGameResults(responseId: $responseId) {
      match
    }
  }
`);

export const QUICKRANK_GAME_RESULTS = graphql(`
  query QuickRankGameResults($responseId: String!) {
    quickRankGameResults(responseId: $responseId) {
      match
    }
  }
`);

export const GET_PROJECT_LEADERBOARD = graphql(`
  query GetProjectLeaderboard($projectId: String!) {
    projectLeaderboard(projectId: $projectId) {
      id
      nickname
      rank
      timeInMs
      points
    }
  }
`);

export const GET_PROJECT_LEADERBOARD_CURRENT_ROW = graphql(`
  query GetProjectLeaderboardCurrentRow($projectId: String!, $nickname: String!) {
    currentRow: projectLeaderboardByNickname(projectId: $projectId, nickname: $nickname) {
      id
      nickname
      rank
      timeInMs
      points
    }
  }
`);

export const IS_PROJECT_NICKNAME_TAKEN = graphql(`
  query IsProjectNicknameTake($nickname: String!, $projectId: String!) {
    projectIsNicknameTaken(nickname: $nickname, projectId: $projectId)
  }
`);
